<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26 26"
    fill="currentColor"
  >
    <rect x="5" y="3" width="6" height="20" rx="1.25" />
    <rect x="15" y="3" width="6" height="20" rx="1.25" />
  </svg>
</template>
